module.exports = __webpack_public_path__ + "static/media/bg.bb095a24.png";